module.exports = __webpack_public_path__ + "static/media/featureImage2.d874bd7a.svg";